import { useParams } from "react-router-dom";
import { useState } from "react";
import Footer from "../components/footer";
import Header from "../components/header";

const Legal = () => {
    const [content, setContent] = useState('<div class="row placeholder-content my-3"></div>');
    const {type} = useParams();
    fetch('https://api.voicecoach.net/view-legal/'+type, {headers: {'Content-type': 'application/json'}})
    .then(res => res.json())
    .then(jr => {setContent(jr.content);});
    return <><Header />
    <section className="container">
    <div dangerouslySetInnerHTML={{__html: content}} />
    </section>
    <Footer /></>
}

export default Legal;